import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Wminput from "../ui-components/wm-form-components/input/Wm.input";
import WmTextarea from "../ui-components/wm-form-components/textarea/Wm.Textarea";
import "./posts.css";
import Categories from "../ui-components/categories/Categories";
import { connect } from "react-redux";
import InputTags from "../ui-components/tags/InputTags";
import Wmbutton from "../ui-components/wm-button/Wm.button";
import Wmswitch from "../ui-components/wm-form-components/switch/Wm-switch";
import axios from "axios";
import API_ENDPOINT from "../wm.api.service";
import { Container, Row, Col } from "react-bootstrap";
import { decode } from "base-64";
import Cookies from "universal-cookie";
import CircularProgress from "@material-ui/core/CircularProgress";
// ACTIONS
import {setSingleQuestionData,editQuestion,editDescriptionQuestion,editIsAnswer,editTagsQuestion,removeEditHeadImageQuestion,editHeadImageQuestion,fetchCategoryFromApiEditQuestion,editCategoryCheckQuestion,isFetchedQuestion,} from "../services/actions/actions";
import WmModals from "../modals/Wm.Modals";
import { useQuery } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { getSinglePostData } from "../functions/posts";
import ServerError from "../Pages/error/500/ServerError";
import Loading from "../Loading/Loading";
const Cookie = new Cookies();
function EditQuestion({questionData,mapDataToState,editQuestion,editDescription,editAnswer,editTags,getCategoryFormApi,handleCategoryCheck,isFetchedQuestions,}) {
  const location = useLocation();
  var tokens = Cookie.get("wmtoken");
  const history = useHistory();
  const lastSegmentOfUrl = window.location.pathname.split("/").pop();
  const questionPreview = () => {
    history.push(`/editpreview_questions`);
  };
  const [isPublishing, setIspublishing] = useState(false);
  const editQuestionData = () => {
    setIspublishing(true);
    var fd = new FormData();
    fd.append("token", decode(tokens));
    fd.append("identity", API_ENDPOINT.identity);
    fd.append("post_type", "question");
    fd.append("post_id", questionData.questionPostID);
    fd.append("title", questionData.editQuestion);
    fd.append("description", questionData.editDescription);
    fd.append("reply_status", questionData.editIsAnswer ? "1" : "0");
    fd.append("post_media", questionData.editQuestionFile);
    fd.append("category", JSON.stringify([...questionData.editCategory]));
    fd.append("tags", JSON.stringify([...questionData.editTags]));
    axios({
      method: "post",
      url: `${API_ENDPOINT.apiURL}Profile/updatePost`,
      data: fd,
    })
      .then(function (response) {
        setIspublishing(false);
        history.push(`/posts`);
      })
      .catch(function (error) {
        setIspublishing(false);
        console.log(error);
      });
  };
  const [isDeleting, setIsDeleting] = useState(false)
  const deleteAnswer = () => {
    setIsDeleting(true)
    var fd = new FormData();
    if (tokens) {
      fd.append("token", decode(tokens));
      fd.append("identity", "wmhandler");
      fd.append("field_id", questionData.questionPostID);
      fd.append("field_name", "POST");
      axios({
        method: "post",
        url: `${API_ENDPOINT.apiURL}Profile/disableUserDataEntry`,
        data: fd,
      })
        .then(function (response) {
          setIsDeleting(false)
          history.push(`/posts`);
        })
        .catch(function (error) {
          console.log(error.response);
          setIsDeleting(false)
        });
    }
  }
  const [deleteModal, setIsDeleteModalOpen] = useState(false);
  const backToLoginPage = () => {
    history.push("/login");
  };


  const {isError,isLoading,isSuccess,error} = useQuery(['singleQuestionData',lastSegmentOfUrl],getSinglePostData,{ refetchOnWindowFocus: false, onSuccess : data => {mapDataToState(data)} })
  if (isLoading) return <><div className="flex items-center justify-center"><Loading className={'w-48'}/></div></>;

  if (isError) return <><div><ServerError message={error.response.status}/></div></>
  if(isSuccess) return (
    <React.Fragment>
      {tokens ? <div className="createBlog -mt-8 container-fluid">
        <h3 className=" mb-4">Edit Question</h3>
        <div className="wm-form-group flex flex-col mb-4">
          <label htmlFor="First name" className="text-sm">Enter Question Here</label>
          <Wminput type="text" name="blogTitle" value={questionData.editQuestion} onChange={(e) => editQuestion(e.target.value)}/>
        </div>
        <div className="row createFormLayoutDivision flex">
          <div className="col-xl-9 col-lg-9 col-md-9">
            <div className="leftCreateSection">
              <div className="wm-form-group flex flex-col mb-4">
                <label htmlFor="First name" className="text-sm">Description</label>
                <WmTextarea value={questionData.editDescription} onChange={(e) => editDescription(e.target.value)}/>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-3 col-md-3 mt-4 lg:mt-0">
            <div className="rightCreateSection">
              <div className="wm-form-group mb-4">
                <div className="catogryWrapper border rounded-md p-3">
                  <Categories
                    mainCategoriesClass="categoryContainer"
                    list={questionData.editCategoryStore}
                    listFromRedux={questionData.editCategory}
                    getCategory={getCategoryFormApi}
                    checkBoxHandler={handleCategoryCheck}
                  />
                </div>
              </div>
              <div className="wm-form-group mb-4">
                <h5 className="mb-2 font-medium text-sm">Tags</h5>
                <div className="tagsWrapper">
                  {questionData?.editTags && <InputTags selected={questionData?.editTags} getTags={editTags}/>}
                </div>
              </div>
              <div className="wm-form-group mb-4">
                <label className="wm_form_label mr-3">Comments on</label>
                <Wmswitch color="success" checked={questionData.editIsAnswer} onChange={() => editAnswer()}/>
              </div>
              <div className="wm-form-group mb-4 flex flex-wrap justify-between">
                <div className="wm-flex-50 px-2">
                  <Wmbutton label="preview" className="rounded mb-3 w-full mr-2" type="button" color="primary" onClick={questionPreview}/>
                </div>
                <div className="wm-flex-50 px-2">
                  <Wmbutton label={isPublishing ? (<CircularProgress className="loader_size_xsm" style={{ color: "white" }}/>) : ("Publish")} className="rounded mb-3 w-full" type="button" color="primary" disable={isPublishing} onClick={() => editQuestionData()}/>
                </div>
                <div className="wm-flex-50 px-2">
                  <Wmbutton label={isDeleting ? (<CircularProgress className="loader_size_xsm" style={{ color: "white" }}/>) : ("Delete")} className="rounded mb-3 w-full" type="button" color="danger" disable={isDeleting} onClick={() => {setIsDeleteModalOpen(true);}}/>
                </div>
                <div className="wm-flex-50 px-2">
                  <Wmbutton label="Back" className="rounded mb-3 w-full" type="button" color="primary" onClick={() => history.push(`/posts`)}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> : backToLoginPage()}

      <WmModals show={deleteModal} onHide={() => setIsDeleteModalOpen(false)} size="md" className="">
        <Container fluid className="py-4">
          <Row>
            <Col md={12}>
              <div className="text-center mb-4">
                <span className="block">Are you sure you want to Delete the content</span>
                <span className="block">This will erase all above content permenantly!!!!</span>
              </div>
            </Col>
            <Col md={12}>
              <div className="text-right">
                <Wmbutton label="Delete" className="rounded w-20 mr-3" type="button" size="sm" color="danger" onClick={(e) => {deleteAnswer();setIsDeleteModalOpen(false);}}/>
                <Wmbutton label="Cancel" className="rounded w-20" type="button" color="primary" onClick={() => {setIsDeleteModalOpen(false);}}/>
              </div>
            </Col>
          </Row>
        </Container>
      </WmModals>
      <ReactQueryDevtools initialIsOpen={false} />
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToState = (dispatch) => {
  return {
    mapDataToState: (value) => {
      dispatch(setSingleQuestionData(value));
    },
    editQuestion: (value) => {
      dispatch(editQuestion(value));
    },
    editDescription: (value) => {
      dispatch(editDescriptionQuestion(value));
    },
    editAnswer: (value) => {
      dispatch(editIsAnswer(value));
    },
    editTags: (value) => {
      dispatch(editTagsQuestion(value));
    },
    removeQuestionImage: () => {
      dispatch(removeEditHeadImageQuestion());
    },
    handleCoverImage: (value) => {
      dispatch(editHeadImageQuestion(value));
    },
    getCategoryFormApi: (value) => {
      dispatch(fetchCategoryFromApiEditQuestion(value));
    },
    handleCategoryCheck: (idx, value, bool) => {
      dispatch(editCategoryCheckQuestion(idx, value, bool));
    },
    isFetchedQuestions: (value) => {
      dispatch(isFetchedQuestion(value));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToState)(EditQuestion);
